module.exports = __webpack_public_path__ + "img/logo.74fe8cbc.jpeg";